import store from "../../store/store";

export const componentKey = "UNSIGNED_VISIT_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setVisitList: (state, action) => {
      state.visitNoteListData = action.payload;
    },
  },
  initialReducerState: {
    visitNoteListData: {},
  },
});

export const { setVisitList } = actions;
